import config from "@Config/index";
import axios from "axios";
import getCookie from "helpers/getCookie";

const fetchSavedBookformData = async ({
  tenancyId,
  inventory_id,
  roomType,
}: {
  tenancyId: number | undefined;
  inventory_id: number;
  roomType: number;
}) => {
  const cookie = getCookie("user_auth_token");
  try {
    const tenancyParam = tenancyId ? `&tenancyId=${tenancyId}` : "";
    const {
      data: { data: reponseData, message },
    } = await axios.get(
      `${config.API_URL}/api/v0/partial_forms?roomtype=${roomType}${tenancyParam}&inventory_id=${inventory_id}`,
      { withCredentials: true },
    );

    return { message, savedData: reponseData ? reponseData.data : null };
  } catch (error) {
    if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`Partial form fetch data -> ${error}`, {
        extra: {
          cookie,
        },
      });
    }
    return { message: "failure", savedData: {} };
  }
};

export default fetchSavedBookformData;
